import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';

const initialState = {
  loading: false,
  loadingTransportationProviders: false,
  mediRoutes: ''
};
const openApi = createSlice({
  name: 'openApi',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loadingTransportationProviders: action.payload
      };
    },
    getMediRoutes(state, action) {
      return {
        ...state,
        mediRoutes: action.payload,
        loading: true
      };
    },
    getMediRouteTransportationProviders(state, action) {
      return {
        ...state,
        mediRouteTransportationProviders: action.payload
      };
    }
  }
});

export default openApi.reducer;

export const OpenApiActions = openApi.actions;

export const createMediRoute = (role) => async (dispatch) => {
  try {
    const res = await api.post(`api/CompanyCredential`, role);
    if (res.status === 200 && res?.data) {
      dispatch(getMediRouteAction());
      toast.success('Credential Saved');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const editMediRoute = (data) => async (dispatch) => {
  try {
    const res = await api.put(`api/CompanyCredential`, data);
    if (res.status === 200 && res?.data) {
      dispatch(getMediRouteAction());
      toast.success('Credential Saved');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const getMediRouteAction = () => async (dispatch) => {
  try {
    const res = await api.get(`api/CompanyCredential`);
    if (res) {
      dispatch(OpenApiActions.getMediRoutes(res?.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    // formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const getMediRouteTransportationProvidersAction =
  () => async (dispatch) => {
    dispatch(OpenApiActions.setLoading(true));
    try {
      const res = await api.get(
        `api/CompanyCredential/TranportationProvidersName`
      );
      if (res) {
        dispatch(OpenApiActions.getMediRouteTransportationProviders(res?.data));
        return Promise.resolve(res?.data);
      }
    } catch (errors) {
      formErrorsHandle(errors.response?.data, []);
      dispatch(OpenApiActions.getMediRouteTransportationProviders([]));
    } finally {
      dispatch(OpenApiActions.setLoading(false));
    }
  };

export const editMediRouteTransportationProviders =
  (data) => async (dispatch) => {
    try {
      const res = await api.put(
        `api/CompanyCredential/TranportationProvider`,
        data
      );
      if (res.status === 200) {
        toast.success('Credential Saved');
        return Promise.resolve(res?.data);
      }
    } catch (errors) {
      formErrorsHandle(errors.response?.data, []);
      return Promise.reject(errors.response?.data);
    }
  };

export const removeMediRouteAction = (setRemoveDialog) => async (dispatch) => {
  try {
    const res = await api.delete(`api/CompanyCredential`);
    if (res.status === 200 && res?.data) {
      dispatch(getMediRouteAction());
      setRemoveDialog('');
      toast.success('Removed successfully!!!');
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
  }
};
